import { Injectable, Type, ComponentRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SlidingPanelService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  private titleSubject = new BehaviorSubject<string>('');
  private componentSubject = new BehaviorSubject<{ component: Type<any>; data?: any } | null>(null);
  private componentRef: ComponentRef<any> | null = null;

  isOpen$ = this.isOpenSubject.asObservable();
  title$ = this.titleSubject.asObservable();
  component$ = this.componentSubject.asObservable();

  open<T>(component: Type<T>, title: string, data?: any) {
    this.titleSubject.next(title);
    this.componentSubject.next({ component, data });
    this.isOpenSubject.next(true);
  }

  setContent<T>(component: Type<T>, data?: any) {
    this.componentSubject.next({ component, data });
  }

  close() {
    this.isOpenSubject.next(false);
    setTimeout(() => {
      if (this.componentRef) {
        this.componentRef.destroy();
        this.componentRef = null;
      }
      this.componentSubject.next(null);
      this.titleSubject.next('');
    }, 300); // Wait for animation to complete
  }

  setComponentRef(ref: ComponentRef<any>) {
    this.componentRef = ref;
  }
} 